module.exports = __webpack_public_path__ + "ebab5287.png";